import * as Button from "./button";
export { Button };



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/button/index.ts
// module id = 8zPH
// module chunks = 2